var exports = {
  "t": "metadataContainer__cp7ong",
};

module.exports = exports;
